<div class="row d-flex mt-2 gx-4 gy-4">
  <!-- Product Card -->
  <div class="prod-card mb-4 col-lg-4 col-md-6 col-sm-12" *ngFor="let product of productList;">
    <div class="card card-body text-center p-3 prod-card-inner position-relative">

      <!-- Loader Overlay -->
      <div *ngIf="product.isLoading" class="loader-overlay d-flex justify-content-center align-items-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- Top Right Button: Add or Remove -->
      <button *ngIf="action == 'Add' && !isProductComboAdded(product)"
        class="btn btn-warning bt-media position-absolute" style="right: 10px; top: 12px;"
        (click)="emitDialog(myDialogMystore, product)">
        Add
      </button>

      <button *ngIf="(action == 'Add' && isProductComboAdded(product)) || action == 'Remove'"
        class="btn btn-warning bt-media position-absolute orange-btn" style="right: 10px; top: 12px;"
        (click)="emitDialog(myDialogRemove, product)">
        Remove
      </button>

      <!-- Top Left: "Designs" Button -->
      <!-- DESIGN BUTTON (top-left) -->
      <div *ngIf="currentTab==2 && (action === 'Add' && product.isAdded === 'Y') || action === 'Remove'"
        class="position-absolute" style="left: 10px; top: 12px; font-size: 12px; cursor: pointer;"
        (click)="cycleDesign(product)">
        <div class="d-flex flex-column align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-arrows-diff">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M11 16h10" />
            <path d="M11 16l4 4" />
            <path d="M11 16l4 -4" />
            <path d="M13 8h-10" />
            <path d="M13 8l-4 4" />
            <path d="M13 8l-4 -4" />
          </svg>
          <span class="text-primary">Designs</span>
        </div>
      </div>

      <!-- Product Image -->
      <div class="img-container">
        <ng-container>
          <canvas class="adwid" *ngIf="isDoogmaRendered(product)" id="canvas{{ product?.uniqueNumber }}"></canvas>
        </ng-container>
        <ng-container *ngIf="!isDoogmaRendered(product)">
          <img class="adwid"
            src="{{ product?.image[0] || 'https://img.freepik.com/premium-vector/cancel-order-vector-icon-with-parcel_116137-7906.jpg' }}"
            alt="No Image Available" />
        </ng-container>
      </div>

      <!-- Product Name & Price -->
      <div class="d-flex justify-content-between align-items-center mt-3">
        <p class="font-weight-bold mb-1 text-uppercase prod-name">
          {{ product.name }}
        </p>
      </div>

      <!-- Product Design Tabs (only for Add(Y) or Remove) -->
      <!-- (UNCHANGED CODE BLOCK) -->

      <!-- Product Color Picker -->
      <div class="d-flex justify-content-center mb-2 flex-wrap" style="gap: 3px 0px;">
        <ng-container *ngFor="let color of product.colorList">
          <div class="color-circle mx-1" [ngStyle]="{
                              'background-color': color.hexValue,
                              'border': color.id === product.selectedColor
                      ? '4px solid #33BFFF'
                      : '1px solid #ccc'
                  }" (click)="action !== 'Store' && checkColor(product, color)">
          </div>
        </ng-container>
      </div>


      <!-- Size Display -->
      <p class="text-dark fnt-12">{{product.availableSizes}}</p>

      <p class="font-weight-bolder mb-1 prod-price">$ {{product?.price}}</p>
    </div>
  </div>

  <!-- Empty List Message -->
  <div *ngIf="productList.length === 0"
    class="text-center w-100 p-4 border rounded shadow-sm bg-light d-flex align-items-center justify-content-center"
    style="height: 10rem;">
    <div>
      <h4 class="text-muted">No Items Available</h4>
      <p class="text-secondary">Start adding products to populate the list.</p>
    </div>
  </div>
</div>
<ng-template id="modal-opened-sty" #myDialogRemove let-dialogRef="dialogRef">
  <div mat-dialog-content class="p-5 d-block text-center" style="padding-bottom: 1rem !important;">
    <p style="font-size: 1rem;"><strong>You are about to remove this product from your store.</strong> </p>
    <p style="font-size: 1rem;line-height: 1.5rem;">If you'd like to find it again later, please visit the "Add
      Products" tab, "Recommended Products." <br>
      Click ‘Proceed’ button below to proceed with removing the product. </p>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-center py-3">
    <button mat-button class="mr-2" (click)="dialogRef.close()">Cancel</button>
    <button class="btn btn-primary" (click)="dialogRef.close('removed')">Proceed</button>
  </div>
</ng-template>

<ng-template #myDialogMystore let-dialogRef="dialogRef">
  <div class="product-added-container p-4">

    <div class="top-bar">
      <button type="button" class="back-arrow" (click)="dialogRef.close('Added'); dialogRef.close()">
        ← Back
      </button>
    </div>

    <div class="content text-center">
      <h2 class="message">Product is added</h2>

      <button class="btn btn-sky" style="width: 50%;" (click)="dialogRef.close('Added');dialogRef.close('Added1')">
        Back To Store Preview
      </button>

      <button class="btn btn-navy mt-3" style="width: 50%;" (click)="dialogRef.close('Added')">
        Add More Products
      </button>
    </div>
  </div>
</ng-template>